import { buildRootEntityActionType } from "features/Application/actions/actionsBuilder";
import ReducerEntityPrefixTypes from "../../../../../enums/reducer/reducerEntityPrefixTypes";
import ReducerNamespaceTypes from "../../../../../enums/reducer/reducerNamespaceTypes";
import * as filterOptions from "features/Application/actions/filterOptions/filterOptionsActionTypes";

import * as filteringItemsActionTypes from "../../../../Application/actions/filteringItems/filteringItemsActionTypes";

export const USER_EDIT_ROLES_SET_ITEMS_FILTER = buildRootEntityActionType(
  ReducerNamespaceTypes.People,
  ReducerEntityPrefixTypes.EditUser,
  filteringItemsActionTypes.SET_ITEMS_FILTER,
);

export const USER_EDIT_ROLES_RESET_ITEMS_FILTER = buildRootEntityActionType(
  ReducerNamespaceTypes.People,
  ReducerEntityPrefixTypes.EditUser,
  filteringItemsActionTypes.RESET_ITEMS_FILTER,
);

export const USER_EDIT_ROLES_FILTER_OPTIONS_FETCH_BEGIN = buildRootEntityActionType(
  ReducerNamespaceTypes.People,
  ReducerEntityPrefixTypes.EditUser,
  filterOptions.FETCH_OPTIONS_BEGIN,
);

export const USER_EDIT_ROLES_FILTER_OPTIONS_FETCH_SUCCESS = buildRootEntityActionType(
  ReducerNamespaceTypes.People,
  ReducerEntityPrefixTypes.EditUser,
  filterOptions.FETCH_OPTIONS_SUCCESS,
);

export const USER_EDIT_ROLES_FILTER_OPTIONS_FETCH_FAILURE = buildRootEntityActionType(
  ReducerNamespaceTypes.People,
  ReducerEntityPrefixTypes.EditUser,
  filterOptions.FETCH_OPTIONS_FAILURE,
);
